(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-offers"] && !Shopify.designMode) return;
  try {
    // Every figure is rendered server-side per variant, so switching colour
  // just needs the freshly-rendered markup swapped in. The section HTML
  // already carries it — no need to redo the discount maths here.
  document.addEventListener('shopify:product:select', (event) => {
    const target = event.target;
    if (!(target instanceof Element) || target.closest('product-card')) return;

    const section = target.closest('.shopify-section');
    const root = section?.querySelector('.product-offers');
    if (!root || !event.promise) return;

    // Keep the disclosure open across a variant switch if the buyer opened it.
    const wasOpen = root.querySelector('.product-offers__more')?.open === true;

    event.promise
      .then(({ detail }) => {
        const fresh = detail?.html?.querySelector('.product-offers');
        if (!fresh) return;
        root.innerHTML = fresh.innerHTML;
        root.dataset.basePrice = fresh.dataset.basePrice;
        root.dataset.variantId = fresh.dataset.variantId;
        const details = root.querySelector('.product-offers__more');
        if (details && wasOpen) details.open = true;
      })
      .catch(() => {});
  });

  function getCurrentQuantity() {
    const input = document.querySelector('input[name="quantity"]');
    const quantity = input ? Number(input.value) : 1;
    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  }

  // Applying only sets the discount on the checkout session — it doesn't put
  // anything in the cart. Landing on /cart afterward with an empty cart
  // looked broken, so the current variant goes in first.
  async function addCurrentVariantToCart(root) {
    const variantId = Number(root?.dataset.variantId || 0);
    if (!variantId) return;
    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: getCurrentQuantity() }] }),
      });
    } catch (error) {
      // Best-effort — the code still gets applied below, just without the
      // item pre-added.
    }
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-offer-apply]');
    if (!(button instanceof HTMLElement) || button.disabled) return;

    const code = button.dataset.offerCode;
    if (!code) return;

    if (navigator.clipboard) {
      navigator.clipboard.writeText(code).catch(() => {});
    }

    button.textContent = 'Applying…';
    button.disabled = true;

    // Shopify only applies a discount code to the checkout session through
    // this endpoint, which needs a real top-level navigation (it sets a
    // cookie on the checkout domain) — there's no AJAX-only way to do this.
    addCurrentVariantToCart(button.closest('.product-offers')).finally(() => {
      window.location.href = `/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent('/cart')}`;
    });
  });
  } catch(e) { console.error(e); }
})();

})();
